import {lastValueFrom, Observable, toArray} from 'rxjs'

export async function collectFrom<T>(observable: Observable<T>): Promise<T[]> {
    return lastValueFrom(observable.pipe(toArray()), {defaultValue:[]})
}
